import { createAction, props } from '@ngrx/store';

export const HelpTextChanged = createAction('[Wizard- Configuration]: Toggle Help Text Status');

export const CampaignNameChanged = createAction(
  '[Wizard- Configuration]: Campaign Name Changed',
  props<{ campaignName: string }>(),
);

export const CampaignCategoryChanged = createAction(
  '[Wizard- Configuration]: Campaign Category Changed',
  props<{ campaignCategoryId: number }>(),
);

export const ChannelChanged = createAction(
  '[Wizard- Configuration]: Channel Changed',
  props<{ channel: string }>(),
);

export const DescriptionChanged = createAction(
  '[Wizard- Configuration]: Description Changed',
  props<{ description: string }>(),
);

export const ExportDataChanged = createAction(
  '[Wizard- Configuration]: Export Data Changed',
  props<{ selectedExportDataSelections: string[] }>(),
);

export const StartDateChanged = createAction(
  '[Wizard- Configuration]: Start Date Changed',
  props<{ startDate: string }>(),
);

export const EndDateChanged = createAction(
  '[Wizard- Configuration]: End Date Changed',
  props<{ endDate: string }>(),
);

export const PriorityChanged = createAction(
  '[Wizard- Configuration]: Priority Changed',
  props<{ priority: string }>(),
);

export const StatusChanged = createAction(
  '[Wizard- Configuration]: Status Changed',
  props<{ status: string }>(),
);

export const NotesChanged = createAction(
  '[Wizard- Configuration]: Notes Changed',
  props<{ notes: string }>(),
);

export const ClearDateField = createAction(
  '[Wizard- Configuration]: Clear Date Field',
  props<{ dateField: string }>(),
);
